import React from 'react';

// Lazy wrappers to code-split framer-motion
export const Motion = React.lazy(() =>
  import('framer-motion').then(mod => ({ default: mod.motion }))
);

export const AnimatePresence = React.lazy(() =>
  import('framer-motion').then(mod => ({ default: mod.AnimatePresence }))
);

// Optional: if you prefer the `m.*` shorthand
export const m = React.lazy(() =>
  import('framer-motion').then(mod => ({ default: mod.m }))
);

// Specific elements (helps with JSX PascalCase rule)
export const MotionDiv = React.lazy(() =>
  import('framer-motion').then(mod => ({ default: mod.motion.div }))
);

export const MotionG = React.lazy(() =>
  import('framer-motion').then(mod => ({ default: mod.motion.g }))
);


export const MotionPath = React.lazy(() =>
  import('framer-motion').then(mod => ({ default: mod.motion.path }))
);

export const MotionImg = React.lazy(() =>
  import('framer-motion').then(mod => ({ default: mod.motion.img }))
);

export { useInView as MotionUseInView } from 'framer-motion';